"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.queueSagas = void 0;
var effects_1 = require("redux-saga/effects");
var EnqueueAction_1 = require("@/pages/common/actions/EnqueueAction");
var Token_1 = require("@/api/remote/public/Token");
var GlobalAction_1 = require("@/pages/common/actions/GlobalAction");
/**
 * Global Queue ensuring CSRF/API calls are sent one by one
 * Concept:
 *  As backend required CSRF token for some API calls,
 *  it provides a ONE-TIME token endpoint which only be valid
 *  if the subsequent call use that ONE-TIME token.
 *  If another ONE-TIME token are sent before the last token
 *  has consumed, the last request will failed as sever only
 *  recognized the new token.
 *
 * Details:
 *  The queue is implement simply by using Redux Saga `actionChannel`
 *  It received the API function call, call arguments and a taskID
 *  from Redux action, It will get token from Token endpoint
 *  and eval the API function. On completion, it send Redux Action
 *  with API response and its corresponding taskID
 *
 * Note:
 *  I argue that CSRF will not work with Content-Type only equals
 *  to "application/json", and modern browser has Cross-origin policy
 *  enforced, so the whole CSRF queue is un-necessary
 */
var watchEnqueue = function () {
    var channel, action, payload, taskId, fn, args, result, token, evaledFn, e_1, e_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.actionChannel(EnqueueAction_1.default.ON_ENQUEUE)];
            case 1:
                channel = _a.sent();
                _a.label = 2;
            case 2:
                if (!true) return [3 /*break*/, 17];
                return [4 /*yield*/, effects_1.take(channel)];
            case 3:
                action = _a.sent();
                payload = action.payload;
                taskId = payload.taskId;
                fn = payload.fn;
                args = payload.args;
                result = null;
                _a.label = 4;
            case 4:
                _a.trys.push([4, 13, , 15]);
                return [4 /*yield*/, effects_1.call(Token_1.getApiToken)];
            case 5:
                token = _a.sent();
                _a.label = 6;
            case 6:
                _a.trys.push([6, 10, , 12]);
                evaledFn = eval(fn);
                return [4 /*yield*/, effects_1.call.apply(void 0, __spreadArrays([evaledFn], args, [token]))];
            case 7:
                result = _a.sent();
                if (!(result && typeof result.data === 'string')) return [3 /*break*/, 9];
                if (!(result.config.url.toLowerCase().indexOf('logout') === 0)) return [3 /*break*/, 9];
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setMessageLocalized('apiAuthError'))];
            case 8:
                _a.sent();
                _a.label = 9;
            case 9: return [3 /*break*/, 12];
            case 10:
                e_1 = _a.sent();
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setMessageLocalized('apiCallError'))];
            case 11:
                _a.sent();
                return [3 /*break*/, 12];
            case 12: return [3 /*break*/, 15];
            case 13:
                e_2 = _a.sent();
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setMessageLocalized('tokenFailed'))];
            case 14:
                _a.sent();
                return [3 /*break*/, 15];
            case 15: return [4 /*yield*/, effects_1.put(EnqueueAction_1.default.enqueueDone(taskId, result))];
            case 16:
                _a.sent();
                return [3 /*break*/, 2];
            case 17: return [2 /*return*/];
        }
    });
};
var queueSagas = { watchEnqueue: watchEnqueue };
exports.queueSagas = queueSagas;
